import { Moment } from 'moment'

import { Persona } from 'api/entities/Persona'

import { MasterCampaignStub } from './MasterCampaignStub'

export interface OffAdCritterCustomOption {
  name: string
  color: string
  order: number
}

export interface MasterCampaignPlanCustomSection {
  title?: string
  showTitle?: boolean
  content?: string
  hideAll?: boolean
}

export interface MasterCampaignPlanExecutiveSummarySection {
  pageTitle?: string
  introduction?: MasterCampaignPlanCustomSection
  aboveCampaignTimeline?: MasterCampaignPlanCustomSection[]
  aboveChannelUtilization?: MasterCampaignPlanCustomSection[]
  channelUtilization?: MasterCampaignPlanCustomSection
  aboveAudienceAndGeoSummary?: MasterCampaignPlanCustomSection[]
  audienceStrategy?: MasterCampaignPlanCustomSection
  geographicTargeting?: MasterCampaignPlanCustomSection
  aboveBudget?: MasterCampaignPlanCustomSection[]
  budget?: MasterCampaignPlanCustomSection
  aboveBottom?: MasterCampaignPlanCustomSection[]
}

export interface MasterCampaignPlanPersonaSection {
  pageTitle?: string
  introduction?: MasterCampaignPlanCustomSection
  abovePersonaList?: MasterCampaignPlanCustomSection[]
}

export interface MasterCampaignPlanMediaPlanSection {
  pageTitle?: string
  campaignDetailsTitle?: string
  budget?: MasterCampaignPlanCustomSection
  aboveCampaignTimeline?: MasterCampaignPlanCustomSection[]
  aboveCampaignDetails?: MasterCampaignPlanCustomSection[]
}

export interface MasterCampaignPlanProjectionsSection {
  pageTitle?: string
  whereAdsAppearTitle?: string
  cpmAndImpressions?: MasterCampaignPlanCustomSection
  auctionBasedPlacements?: MasterCampaignPlanCustomSection
  ctvPlacementCategories?: MasterCampaignPlanCustomSection
  internetAdPlacements?: MasterCampaignPlanCustomSection
  geographicDistribution?: MasterCampaignPlanCustomSection
  billboardLocations?: MasterCampaignPlanCustomSection
}

export interface MasterCampaignPlan {
  accountName: string
  name: string
  planSummary: string
  planDetails: string
  audienceSummary: string
  audienceDetails: string
  geoSummary: string
  geoDetails: string
  seasonalitySummary: string
  seasonalityDetails: string
  aiUsedMonthlyBudgetMin: number
  aiUsedMonthlyBudgetMax: number
  aiUsedStartDate: Moment
  marketAnalysisAvailable: boolean
  marketingPlanAvailable: boolean
  campaignDetailsAndRationaleAvailable: boolean
  aiUsedDurationInMonths: number
  durationInMonths: number
  personas: Persona[]
  marketAnalysisContent: string
  masterCampaignStub: MasterCampaignStub
  inEditMode: boolean
  internetMarginOfError: number
  tvMarginOfError: number
  billboardMarginOfError: number
  highlightedDomainIds?: string[]
  tvNetworkDistribution?: Record<string, number>
  offAdCritterCustomOptions?: OffAdCritterCustomOption[]
  clientPreviewShowExecutiveSummary?: boolean
  clientPreviewShowMarketAnalysis?: boolean
  clientPreviewShowPersonas?: boolean
  clientPreviewShowMediaPlan?: boolean
  clientPreviewShowProjections?: boolean
  executiveSummarySection?: MasterCampaignPlanExecutiveSummarySection
  personaSection?: MasterCampaignPlanPersonaSection
  mediaPlanSection?: MasterCampaignPlanMediaPlanSection
  projectionsSection?: MasterCampaignPlanProjectionsSection
}

export enum MasterCampaignPlanResourceType {
  MarketAnalysis = 'MarketAnalysis',
  MarketingPlan = 'MarketingPlan',
  CampaignDetailsAndRationale = 'CampaignDetailsAndRationale'
}
